/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import StatsBoard from "./StatsBoard";
import "./BusinessSales.css";

// Business · "you". Sales on the left, what the rule turned them into on the
// right, and the charity-sale lines that outperform everything else.
class BusinessSales extends Component {
  render() {
    const vm = this.props.vm;
    const s = vm.sales;
    return (
      <div className="Marketplace-Sales">
        <StatsBoard data={s} m={vm.m} />

        <div className="Marketplace-Sales-lower">
          <div className="Marketplace-card">
            <div className="Marketplace-cardHead">
              <span className="Marketplace-cardTitle">{vm.m.salesProductsTitle}</span>
              <span className="Marketplace-cardNote">{s.productsNote}</span>
            </div>
            <div className="Marketplace-Sales-table">
              <div className="Marketplace-Sales-row Marketplace-Sales-row--head">
                <span>{vm.m.colProduct}</span>
                <span className="Marketplace-right">{vm.m.colOrders}</span>
                <span className="Marketplace-right">{vm.m.colSales}</span>
                <span className="Marketplace-right">{vm.m.colGiving}</span>
                <span className="Marketplace-right">{vm.m.colVsOther}</span>
              </div>
              {s.products.map((p) => (
                <div className="Marketplace-Sales-row" key={p.id}>
                  <div>
                    <div className="Marketplace-Sales-name">{p.name}</div>
                    <div className="Marketplace-Sales-note">{p.note}</div>
                  </div>
                  <span className="Marketplace-right Marketplace-Sales-cell">{p.orders}</span>
                  <span className="Marketplace-right Marketplace-Sales-cell">{p.sales}</span>
                  <span className="Marketplace-right Marketplace-Sales-giving">{p.giving}</span>
                  <span className="Marketplace-right Marketplace-Sales-lift">{p.lift}</span>
                </div>
              ))}
              <div className="Marketplace-Sales-row Marketplace-Sales-row--baseline">
                <div>
                  <div className="Marketplace-Sales-name Marketplace-Sales-name--muted">{s.otherProduct.name}</div>
                  <div className="Marketplace-Sales-note">{s.otherProduct.note}</div>
                </div>
                <span className="Marketplace-right Marketplace-Sales-cell">{s.otherProduct.orders}</span>
                <span className="Marketplace-right Marketplace-Sales-cell">{s.otherProduct.sales}</span>
                <span className="Marketplace-right Marketplace-Sales-cell">{s.otherProduct.giving}</span>
                <span className="Marketplace-right Marketplace-Sales-baselineLift">{s.otherProduct.lift}</span>
              </div>
            </div>
            <div className="Marketplace-Sales-badge">
              <div className="Marketplace-Sales-badgeCopy">{s.badgeNote}</div>
              <div className="Marketplace-Sales-badgeBtn">{vm.m.badgeSettings}</div>
            </div>
          </div>

          <div className="Marketplace-Sales-side">
            <div className="Marketplace-card">
              <div className="Marketplace-cardTitle">{s.allocationTitle}</div>
              <div className="Marketplace-Sales-alloc">
                {s.allocation.map((a) => (
                  <div key={a.id}>
                    <div className="Marketplace-Sales-allocHead">
                      <span className="Marketplace-Sales-allocName">{a.name}</span>
                      <span className="Marketplace-Sales-allocAmount">{a.amount}</span>
                    </div>
                    <div className="Marketplace-bar">
                      <div className="Marketplace-barFill" style={{ width: a.w }} />
                    </div>
                  </div>
                ))}
                {!s.allocation.length && (
                  <div className="Marketplace-empty">
                    {vm.m.planEmptyBody}
                    <div className="Marketplace-btnGhost Marketplace-btn--block" onClick={s.goDiscover}>
                      {vm.m.planEmptyCta}
                    </div>
                  </div>
                )}
              </div>
              {!!s.allocation.length && (
                <div className="Marketplace-btnGhost Marketplace-btn--block" onClick={s.goPortfolio}>
                  {vm.m.allocationAdjust}
                </div>
              )}
            </div>
            <div className="Marketplace-note">
              <div className="Marketplace-noteTitle">{vm.m.settlementTitle}</div>
              <div className="Marketplace-Sales-settlement">{s.settlement}</div>
              <div className="Marketplace-noteBody">{vm.m.settlementBody}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BusinessSales.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default BusinessSales;
